import {
  type ClientPortalEoirCourtInformation,
  type ClientPortalEoirNextHearing,
} from '@/lib/queries/case-dashboard/types'
import { cn } from '@/lib/utils'

import { CourtInformationCard } from '../cards/court-information-card/court-information-card'
import { NextHearingInfoCard } from '../cards/next-hearing-info-card/next-hearing-info-card'

export interface AdditionalInformationEoirProps {
  nextHearingData?: ClientPortalEoirNextHearing | null
  courtData?: ClientPortalEoirCourtInformation | null
}

export const AdditionalInformationEoir = ({ nextHearingData, courtData }: AdditionalInformationEoirProps) => {
  return (
    <div className={cn('flex flex-col gap-y-5 lg:grid lg:grid-cols-2 lg:gap-5', 'mt-5')}>
      <NextHearingInfoCard nextHearingData={nextHearingData} />
      <CourtInformationCard courtData={courtData} />
    </div>
  )
}
